module.exports = __webpack_public_path__ + "images/emoji/construction.c134864689e30fdc7be4.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/construction.png
// module id = 4LJn
// module chunks = 13